export const globalMiddleware = []
export const namedMiddleware = {}